import type { FC, ReactElement } from 'react';

import { ChatControlPlain } from '@pp/core/src/components/nav/navControls/chatControl/ChatControlPlain';
import { Logger } from '@pp/core/src/logger/Logger';
import { useActiveDialogCleaner, useDrawerHidden } from '@pp/core/src/store/actions/useActiveDialogCleaner';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { headerActions } from '@pp/core/src/store/slices/header/slice';
import { HeaderModal } from '@pp/core/src/store/slices/header/types';

import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../store/slices/highflyerGame/slice';

export const ChatControlConnected: FC = (): ReactElement | null => {
  const dispatch = useCoreDispatch();
  const isChatDisabled = useConfigSlice.isChatDisabled();
  const drawerHidden = useDrawerHidden();
  const cleanDialogs = useActiveDialogCleaner();
  const disabledJurisdictionChat = !!useConfigSlice.jurisdiction()?.disableChat;
  const isPrivateTable = useConfigSlice.isPrivateTable();

  const isGameChatTabSelected = useHighflyerGameStateSlice.getSelectedHeader() == HeaderModal.Chat;

  if (isChatDisabled || disabledJurisdictionChat) {
    return null;
  }

  return (
    <ChatControlPlain
      condition={isGameChatTabSelected}
      onClick={(): void => {
        drawerHidden && cleanDialogs();

        if (drawerHidden || !isGameChatTabSelected) {
          dispatch(highflyerGameStateActions.setChatClosed(false));
          dispatch(highflyerGameStateActions.setSelectedHeader(HeaderModal.Chat));
          dispatch(headerActions.setOpenedModal(HeaderModal.Chat));
          Logger.logEvent('click', 'chatModalOpen', Date.now(), 1, '', false);
        } else {
          dispatch(highflyerGameStateActions.setSelectedHeader(null));
          dispatch(highflyerGameStateActions.setChatClosed(true));
          dispatch(headerActions.setOpenedModal(null));
        }
      }}
      isPrivateTable={isPrivateTable}
    />
  );
};
